export const ERRORS = {
  couldNotComment: 'Could not comment on issue',
  couldNotCloseIssue: 'Could not close issue',
  couldNotDeleteComment: 'Could not delete this comment',
  couldNotEditComment: 'Could not edit issue comment',
  couldNotEditCommentStale: 'The content you are editing has changed. Please copy your edits and refresh the page.',
}
